import { Control, useController } from "react-hook-form";
import { FC, useCallback, useState } from "react";
import { DatePicker } from "theme";
import { DatePickerProps } from "@mui/x-date-pickers";
import { uk } from "date-fns/locale/uk";
import { format } from "date-fns";
import DatepickerPopper from "../../theme/components/DatePicker/DatepickerPopper.tsx";


export type ControlledSelectProps = Omit<DatePickerProps<any, any>, "value" | "onChange"> & {
  control: Control<any>;
  onOptionsChange?: () => void;
}

const ControlledDatePicker: FC<ControlledSelectProps> = ({
                                                           control,
                                                           name,
  onOptionsChange,
                                                           ...props
                                                         }) => {
  const { field } = useController({
    control,
    name: name || "",
  });
  const [value, setValue] = useState<Date | null>(field.value);

  const onSingleChange = useCallback(
    (newValue: Date | null) => {
      setValue(newValue);
      field.onChange(newValue);
      onOptionsChange?.();
    },
    [field, onOptionsChange],
  );

  return (
    <DatePicker value={value} onChange={onSingleChange} {...props} dayOfWeekFormatter={(d) =>
      format(d, "E", {
        locale: uk,
      })
    }
                slots={{
                  popper: DatepickerPopper,
                }}
                disablePast
                showDaysOutsideCurrentMonth />
  );
};

export default ControlledDatePicker;
